import { services, ritualGroups } from './catalog';
import { getPriceView } from '../utils/pricing';

/** Reprice shared/old booking links using catalogue prices, never the URL's amount. */
export function bookingPrice(serviceName: string, planName: string, discountActive: boolean, multiplier: number) {
  const service = services.find(s => s.title === serviceName || s.paymentName === serviceName || (serviceName === 'Panchamukhi Healing' && s.slug === 'hanuman-healing') || (serviceName === 'Therapy & Counselling' && s.slug === 'therapy'));
  const plan = service?.plans.find(p => `${p.title} — ${p.duration}` === planName);
  if (plan) return getPriceView(String(plan.price), discountActive, multiplier);
  const ritual = ritualGroups.find(r => r.title === serviceName);
  if (ritual) {
    const intention = ritual.items.find(item => planName === `${item} — 1 day` || planName === `${item} — 7 days`);
    if (intention) return getPriceView(String(planName.endsWith(' — 7 days') ? 2300 : ritual.price), discountActive, multiplier);
  }
  return null;
}
